module.exports = __webpack_public_path__ + "img/conny-stage3-sulking.0629dd43.png";